module.exports = __webpack_public_path__ + "img/MDI-information-outline-new.049a9855.svg";